import { FilterSpecification, Map } from "maplibre-gl";
import { MutableRefObject } from "react";
import {
  FILTER_XWALK,
  SCENARIO_FILTER_XWALK,
} from "../../../../constants/schools";
import { SchoolType } from "../../../../editing_planning/data_requirements";
import { ScenarioKey } from "../../../../types/data/api";
import { MAP_LAYERS } from "../constants";
import { OPACITIES } from "./styleConstants";
import { schoolPointColoring } from "../layers";

export const filterSchoolsByLevel = (
  map: MutableRefObject<Map>,
  level: SchoolType,
  scenario: ScenarioKey,
) => {
  map.current.setFilter(MAP_LAYERS.schoolPoints, [
    "all",
    FILTER_XWALK[level],
    SCENARIO_FILTER_XWALK[scenario],
  ] as FilterSpecification);
  map.current.setPaintProperty(
    MAP_LAYERS.schoolPoints,
    "circle-color",
    schoolPointColoring,
  );
};

export const colorBlocksByLevelAndScenario = (
  map: MutableRefObject<Map>,
  level: SchoolType,
  scenario: ScenarioKey,
) => {
  map.current.setPaintProperty(MAP_LAYERS.planningBlocks, "fill-color", [
    "get",
    `${level.toLowerCase()}_${scenario}_color`,
  ]);
};

export const scenarioBoundaryOpacity = (
  map: MutableRefObject<Map>,
  level: SchoolType,
  scenario: number,
) => {
  map.current?.setPaintProperty(MAP_LAYERS.schoolBoundaries, "line-opacity", [
    "case",
    [
      "all",
      ["==", ["get", "sch_level"], level],
      ["==", ["get", "scenario_id"], scenario === 0 ? null : scenario],
    ],
    OPACITIES.HIGHLIGHTED,
    OPACITIES.INVISIBLE,
  ]);
};

export const hatchOnBoundaryChanges = (
  map: MutableRefObject<Map>,
  scenario: number,
  level: SchoolType,
) => {
  const show = !(scenario === 0);
  map.current.setFilter(MAP_LAYERS.planningBlockChanges, [
    "all",
    ["==", ["get", `${level.toLowerCase()}_bund_chg`], true],
    show,
  ]);
};

export const shadeDualRightsChanges = (
  map: MutableRefObject<Map>,
  scenario: number,
  level: SchoolType,
) => {
  const show = !(scenario === 0 || level !== "MS");
  map.current.setLayoutProperty(MAP_LAYERS.dualRights, "visibility", "visible");
  map.current.setFilter(MAP_LAYERS.dualRights, [
    "all",
    ["==", ["get", `dual_right_status`], "had_dr"],
    show,
  ]);
};
